import React, { useCallback } from 'react'
import { connect } from 'react-redux'

import { toastsType } from 'models/propTypes'

import { getToasts } from 'models/toasts/selectors'

import * as types from 'toasts/toastTypes.js'

import AddedToBagToast from 'toasts/AddedToBagToast'
import RotatePhoneToast from 'toasts/RotatePhoneToast'

const ToastDisplay = ({ toasts }) => {
    const getToast = useCallback((toast, index) => {
        switch (toast.toastType) {
            case types.ADDED_TO_BAG_TOAST:
                return <AddedToBagToast toast={toast} key={index} />
            case types.ROTATE_PHONE:
                return <RotatePhoneToast key={index} />
            default:
                return null
        }
    }, [])

    return <>{toasts.map(getToast)}</>
}

ToastDisplay.propTypes = {
    toasts: toastsType.isRequired,
}

const mapStateToProps = (state) => ({
    toasts: getToasts(state),
})

export default connect(mapStateToProps)(ToastDisplay)
